<ejs-dialog #dialog [buttons]='dlgButtons' isModal='true' [animationSettings]='animationSettings' zIndex='8001'
    [closeOnEscape]='false' [showCloseIcon]='false' [customers]='customers'>

    <div class="card">
        <div class="card-header bg-primary">
            <h3 class="card-title text-white" tabindex="0" role="heading" aria-label="Select a company" aria-level="3"> Select a company</h3>
        </div>
        <div class="card-body">
            <p role="paragraph" tabindex="0" aria-label="Pick a company">Before you start, let's pick a company to work with.</p>
            <div style="position: relative;">
                <ejs-dropdownlist #csCustomersddw id='csCustomersddw' [dataSource]='customers' [fields]='fields'
                    (change)='customerChanged($event)' [placeholder]='customersWaterMark' [popupHeight]='ddwHeight'
                    [allowFiltering]="true"
                    [filterType]="'Contains'"  
                    [ignoreCase]="true"
                    [showClearButton]="true"
                    [sortOrder]="'Ascending'"
                    [enabled]="!customersLoading"
                >
                </ejs-dropdownlist>
                <div *ngIf="customersLoading" style="position: absolute; top: 0; right: 30px; bottom: 0; display: flex; align-items: center; z-index: 100;">
                    <span class="fas fa-spinner custom-spinner-icon text-primary" style="font-size: 1.25em;"></span>
                </div>
            </div>
        </div>
    </div>
</ejs-dialog>
